/* Donate page: video pop-up, PDF download, donation tip panels */

(function () {
  /* ---------- Video pop-up ---------- */
  function embedFor(url) {
    var u;
    try {
      u = new URL(url, window.location.href);
    } catch (e) {
      return null;
    }
    var host = u.hostname.replace(/^www\./, '');
    var id = null;

    if (host === 'youtu.be') id = u.pathname.slice(1);
    else if (host.indexOf('youtube.com') > -1) {
      if (u.pathname === '/watch') id = u.searchParams.get('v');
      else if (/^\/(embed|shorts|live)\//.test(u.pathname)) id = u.pathname.split('/')[2];
    }
    if (id) {
      return { type: 'iframe', src: 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1' };
    }

    if (host.indexOf('vimeo.com') > -1) {
      var m = u.pathname.match(/(\d+)/);
      if (m) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };
    }

    if (/\.(mp4|webm|mov)(\?|$)/i.test(u.pathname + u.search)) return { type: 'video', src: u.href };
    return null;
  }

  var openers = document.querySelectorAll('[data-video-modal-open]');
  openers.forEach(function (opener) {
    var wrap = opener.closest('.donate-layout__block');
    var modal = wrap && wrap.querySelector('[data-video-modal]');
    if (!modal) return;
    document.body.appendChild(modal);

    var frame = modal.querySelector('[data-video-modal-frame]');
    var lastFocus = null;

    function close() {
      modal.hidden = true;
      frame.innerHTML = '';
      document.documentElement.classList.remove('donate-video-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    // Capture phase on document so this runs before the theme's own YouTube link
    // handler (theme.videoModal), which would otherwise open a second pop-up.
    document.addEventListener('click', function (e) {
      if (!opener.contains(e.target)) return;
      var embed = embedFor(opener.getAttribute('href'));
      if (!embed) return; // not an embeddable link: fall back to normal navigation
      e.preventDefault();
      e.stopPropagation();
      lastFocus = opener;

      var node;
      if (embed.type === 'iframe') {
        node = document.createElement('iframe');
        node.src = embed.src;
        node.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        node.allowFullscreen = true;
        node.title = modal.getAttribute('aria-label') || 'Video';
      } else {
        node = document.createElement('video');
        node.src = embed.src;
        node.controls = true;
        node.autoplay = true;
        node.playsInline = true;
      }
      frame.innerHTML = '';
      frame.appendChild(node);

      modal.hidden = false;
      document.documentElement.classList.add('donate-video-open');
      document.addEventListener('keydown', onKey);
      modal.querySelector('.donate-video-modal__close').focus();
    }, true);

    modal.querySelectorAll('[data-video-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
  });

  /* ---------- PDF download ---------- */
  document.querySelectorAll('a[data-download]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      var name;
      try {
        name = decodeURIComponent(new URL(href, window.location.href).pathname.split('/').pop()) || 'download';
      } catch (err) {
        name = 'download';
      }
      fetch(href, { mode: 'cors' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.blob();
        })
        .then(function (blob) {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = name;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            URL.revokeObjectURL(a.href);
            a.remove();
          }, 1000);
        })
        .catch(function () {
          window.open(href, '_blank', 'noopener');
        });
    });
  });

  /* ---------- Donation tips: hover on desktop (CSS), tap to toggle on touch ---------- */
  var touchOnly = window.matchMedia('(hover: none)');
  var wraps = document.querySelectorAll('.donation-form__tipwrap');

  function closeTips(except) {
    wraps.forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.donation-form__link--tip');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  wraps.forEach(function (wrap) {
    var btn = wrap.querySelector('.donation-form__link--tip');
    btn.addEventListener('click', function () {
      if (!touchOnly.matches) return;
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      closeTips(wrap);
    });
  });

  document.addEventListener('click', function (e) {
    if (!touchOnly.matches || e.target.closest('.donation-form__tipwrap')) return;
    closeTips(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTips(null);
  });
})();
